// extracted by mini-css-extract-plugin
export default {"container":"header_container-wiFqg","tagline":"header_tagline-ToubK","logo":"header_logo-q8Zx0"};